import { Toaster as Sonner, type ToasterProps } from "sonner";

/** App-wide toast host. Colors come from design tokens (styles.css). */
export function Toaster(props: ToasterProps) {
  return <Sonner theme="system" position="bottom-right" {...props} />;
}

export { toast } from "sonner";
